import { DataBean } from "../DataBean";

export class MaintenanceTypeItem extends DataBean {
  public async getMaintenanceTypeItemCatalogPorPropiedades(
    properties: any,
    maxRows: number
  ): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "java.util.List_getMaintenanceTypeItemCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async deleteMaintenanceTypeItem(
    idmaintenancetypeitem: number
  ): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "boolean_deleteMaintenanceTypeItem_Number",
      [idmaintenancetypeitem]
    );
  }

  public async updateMaintenanceTypeItem(bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.orange.finance.processcontract.bean.MaintenanceTypeItem_updateMaintenanceTypeItem_com.orange.finance.processcontract.bean.MaintenanceTypeItem",
      [
        {
          DataBeanProperties: bean,
          DataBeanName:
            "com.orange.finance.processcontract.bean.MaintenanceTypeItem",
        },
      ]
    );
  }
}
